import * as React from 'react';
import { MapContainer } from '../components/container/index.esm.js';
import { withScriptLoader } from '../components/script-loader/index.esm.js';
import { MapType } from '../types/index.esm.js';
const MapContext = React.createContext(null);
const Map = ({
  children,
  ...rest
}) => withScriptLoader(React.createElement(MapContainer, {
  ...rest
}, children), {
  ...rest
});
const defaultProps = {
  clustering: false,
  height: '100%',
  mapStyle: 'mapbox://styles/mapbox/streets-v10',
  mapType: MapType.GOOGLE,
  markerType: 'price',
  showPopup: false,
  width: '100%'
};
Map.defaultProps = defaultProps;
export { Map, MapContext };